import React from 'react';
import './primary cta long.css'

const PrimaryctaLong = (props) => {
    return ( 
        <button className='long-cta-bg'>
            <nav className='yellow-cont-bg'>
                <h2 className='cta-text-primary'>{props.title}</h2>
            </nav>
        </button>
     );
}
 
export default PrimaryctaLong;